import React, { FC } from 'react';
import { TSiteType } from 'types/site.types';
import { SiteTypeLabels } from 'utils/site.utils';
import { EFilterType, IFilterComponentProps } from './filter.types';
import FilterAutocompleteSelection, {
  IFilterAutocompleteSelectItem,
} from 'components/Filter/FilterAutocompleteSelection';

const SiteTypeFilter: FC<IFilterComponentProps<EFilterType.SITE_TYPE>> = ({ value, onChange }) => {
  const items: IFilterAutocompleteSelectItem[] = [
    ...Object.entries(SiteTypeLabels).map(([key, label]) => ({
      id: key,
      title: label,
    })),
  ];

  const allItemSelected = !value?.length;

  const handleSelectionChange = (selectedItems?: string | string[]) => {
    const newSelection = selectedItems as string[] | undefined;
    if (allItemSelected) {
      // Remove the 'all' item from the selection
      if (!!newSelection) {
        onChange(newSelection.filter(item => item !== 'all') as TSiteType[]);
      } else {
        onChange(null);
      }
    } else {
      // Add the 'all' item to the selection
      if (!newSelection) {
        onChange(null);
      } else {
        onChange(newSelection?.filter(item => item !== 'all') as TSiteType[]);
      }
    }
  };

  return (
    <FilterAutocompleteSelection
      label="Site type"
      closeAfterSelection
      multiple
      placeholder="All site types"
      items={items}
      selected={!value?.length ? ['all'] : value}
      onSelectionChange={handleSelectionChange}
    />
  );
};

export default SiteTypeFilter;
